import {
  BOX_SHADOWS,
  FONTS,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from "../../constants";

import { createStyles, makeStyles } from "@material-ui/core";
import { Chart } from "react-google-charts";
import { formatNumber } from "../../helpers/FormatNumber";

const useStyles = makeStyles((theme) =>
  createStyles({
    chartContainer: {
      width: "100%",
      marginLeft: "5%",
    },
    chartContainer2: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      backgroundColor: "white",
      boxShadow: BOX_SHADOWS,
      borderRadius: "10px",
    },
  })
);

export function Hist({ state, data, isCat }) {
  const classes = useStyles();
  if (data.length === 0) {
    return <div></div>;
  }

  let binWidth = 1;
  if (data.length > 1) {
    binWidth = data[1][0] - data[0][0];
  }

  let ticks = [];
  for (let i = 0; i < data.length; i++) {
    ticks.push({
      v: data[i][0] - binWidth / 2,
      f: formatNumber(data[i][0]) + (isCat ? "%" : ""),
    });
  }
  if (data[0].length < 3) {
    for (let d of data) {
      d.push("stroke-color: black; stroke-width: 2;");
    }
  }
  data = [["x", "Total", { role: "style" }], ...data];

  return (
    <div className={classes.chartContainer}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div className={classes.chartContainer2}>
          <div
            style={{
              height: "100%",
              width: "100%",
              marginLeft: "0%",
            }}
          >
            <Chart
              style={{
                height: "450px",
                width: "100%",
              }}
              chartType={"ColumnChart"}
              loader={<div>Loading Chart</div>}
              data={data}
              options={{
                series: [
                  {
                    color: SECONDARY_COLOR,
                    dataOpacity: 0.8,
                  },
                ],
                pointSize: 3,
                title: "Counts by Classes",
                legend: { position: "none" },
                chartArea: {
                  width: "90%",
                  height: "100%",
                  top: 10,
                  bottom: 50,
                  left: 70,
                },

                vAxis: {
                  minorGridlines: { color: "white" },
                  textStyle: { fontName: FONTS },
                  gridlines: { color: "rgb(220,220,220)" },
                  baselineColor: "rgb(220,220,220)",
                },
                hAxis: {
                  minorGridlines: { color: "white" },
                  baselineColor: "rgb(220,220,220)",
                  gridlines: { color: "white" },
                  baseline: { undefined },
                  textStyle: { fontName: FONTS },

                  ticks: ticks,
                },

                bar: { groupWidth: "100%" },

                annotations: {
                  alwaysOutside: true,
                  textStyle: {
                    color: PRIMARY_COLOR,
                    fontSize: 14,
                    fontFamily: FONTS,
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
